(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["121-cart-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  function feePlan(state) {
    if (!state || state.currency !== 'GBP' || state.taxesIncluded) return { error: 'unsupported' };
    if (!Number.isSafeInteger(state.goods) || state.goods < 0 || !Array.isArray(state.fees)) return { error: 'error' };
    const required = state.goodsCount > 0 && state.goods < 5000;
    const updates = {};
    state.fees.forEach((line, index) => {
      const target = required && index === 0 ? 1 : 0;
      if (line.quantity !== target) updates[line.key] = target;
    });
    const add = required && state.fees.length === 0;
    let error = state.requestCount > 0 ? 'request' : null;
    if (!add && Object.keys(updates).length === 0 && required && state.feeTotal !== 700) error = 'feePrice';
    return { required, updates, add, error, feeRemaining: Math.max(0, 5000 - state.goods), deliveryRemaining: Math.max(0, 25000 - state.goods) };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { feePlan };
  if (typeof document === 'undefined') return;
  function init() {
    const element = document.getElementById('w121-cart-config');
    if (!element || window.WholesaleCart) return;
    const config = JSON.parse(element.textContent);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'GBP' });
    const format = (value) => money.format(value / 100);
    let state = null;
    let error = null;
    let pending = 0;
    let chain = Promise.resolve();
    let checkoutStarted = false;
    const channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('w121-cart-v1') : null;
    const internalHeaders = { 'Content-Type': 'application/json', 'X-121-Cart-Internal': '1' };
    const canCheckout = () => Boolean(config.ready && !pending && !error && state && state.payableCount > 0 && !feePlan(state).error && !feePlan(state).add && Object.keys(feePlan(state).updates).length === 0);

    function paint() {
      document.documentElement.toggleAttribute('data-w121-busy', pending > 0);
      document.querySelectorAll('[data-w121-checkout]').forEach((button) => {
        button.disabled = !canCheckout();
        button.setAttribute('aria-disabled', String(!canCheckout()));
      });
      document.querySelectorAll('[data-w121-status]').forEach((node) => {
        node.textContent = pending ? config.text.busy : error ? config.text[error] || config.text.error : !config.ready ? config.text.paused : '';
      });
      document.querySelectorAll('[data-w121-retry]').forEach((node) => { node.hidden = !error || pending > 0; });
      if (!state) return;
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = `${state.payableCount + state.requestCount} ${state.payableCount + state.requestCount === 1 ? 'item' : 'items'}`;
      });
      document.querySelectorAll('[data-cart-total]').forEach((node) => { node.textContent = format(state.total || 0); });
      document.querySelectorAll('[data-cart-a11y]').forEach((node) => {
        node.textContent = `${state.payableCount + state.requestCount} items, ${format(state.total || 0)}`;
      });
      const plan = feePlan(state);
      document.querySelectorAll('[data-w121-summary]').forEach((summary) => {
        summary.hidden = state.goodsCount === 0;
        summary.querySelector('[data-w121-goods]').textContent = format(state.goods);
        summary.querySelector('[data-w121-fee-stage]').hidden = plan.feeRemaining === 0;
        summary.querySelector('[data-w121-delivery-stage]').hidden = plan.feeRemaining > 0;
        summary.querySelector('[data-w121-fee-target]').textContent = `${plan.feeRemaining === 0 ? '✓ ' : ''}${config.text.feeShort}`;
        summary.querySelector('[data-w121-fee-progress]').value = Math.min(100, state.goods / 50);
        summary.querySelector('[data-w121-delivery-progress]').value = Math.min(100, state.goods / 250);
        summary.querySelector('[data-w121-fee-message]').textContent = plan.feeRemaining === 0 ? config.text.feeRemoved : config.text.feeRemaining.replace('[amount]', format(plan.feeRemaining));
        summary.querySelector('[data-w121-delivery-message]').textContent = plan.deliveryRemaining === 0 ? config.text.deliveryUnlocked : config.text.deliveryRemaining.replace('[amount]', format(plan.deliveryRemaining));
        summary.querySelector('[data-w121-fee-line]').hidden = state.feeQuantity === 0;
        summary.querySelector('[data-w121-fee-value]').textContent = `${format(state.feeTotal)} ${config.text.plusVat}`;
      });
    }

    async function request(url, options = {}) {
      const response = await fetch(url, { ...options, cache: 'no-store', headers: { ...internalHeaders, ...options.headers } });
      if (!response.ok) throw new Error('error');
      return response;
    }

    function readState(html) {
      if (typeof html !== 'string') return null;
      const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-w121-state]');
      if (!node) return null;
      return JSON.parse(node.textContent);
    }

    async function snapshot() {
      const url = new URL(config.cartUrl, location.origin);
      url.searchParams.set('section_id', '121-cart-state');
      const html = await (await request(url)).text();
      const nextState = readState(html);
      if (!nextState) throw new Error('error');
      return nextState;
    }

    async function reconcile(initialState = null) {
      let changed = false;
      for (let pass = 0; pass < 3; pass++) {
        state = pass === 0 && initialState ? initialState : await snapshot();
        const plan = feePlan(state);
        if (plan.error) throw new Error(plan.error);
        if (Object.keys(plan.updates).length) {
          await request(`${config.root}cart/update.js`, { method: 'POST', body: JSON.stringify({ updates: plan.updates }) });
          changed = true;
        } else if (plan.add) {
          if (!/^\d+$/.test(config.feeId)) throw new Error('error');
          await request(`${config.root}cart/add.js`, { method: 'POST', body: JSON.stringify({ items: [{ id: Number(config.feeId), quantity: 1 }] }) });
          changed = true;
        } else return { state, changed };
      }
      throw new Error('error');
    }

    async function sections(ids, context = config.cartUrl) {
      const result = {};
      for (let i = 0; i < ids.length; i += 5) {
        const url = new URL(context, location.origin);
        if (url.origin !== location.origin) throw new Error('error');
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', ids.slice(i, i + 5).join(','));
        Object.assign(result, await (await request(url)).json());
      }
      if (ids.some((id) => typeof result[id] !== 'string')) throw new Error('error');
      return result;
    }

    function cartSections() {
      return [...new Set(['cart-drawer', 'cart-icon-bubble', ...['main-cart-items', 'main-cart-footer'].map((id) => document.getElementById(id)?.dataset.id).filter(Boolean)])];
    }

    function renderSections(data, skip = []) {
      const parser = new DOMParser();
      Object.entries(data).forEach(([id, html]) => {
        if (skip.includes(id) || !html) return;
        const source = parser.parseFromString(html, 'text/html');
        const selectors = id === 'cart-drawer' ? ['#CartDrawer .drawer__inner'] : id === 'cart-icon-bubble' ? ['#cart-icon-bubble'] : ['#main-cart-items .js-contents', '#main-cart-footer .js-contents'];
        selectors.forEach((selector) => {
          const target = document.querySelector(selector);
          const replacement = source.querySelector(selector) || (id === 'cart-icon-bubble' ? source.querySelector('.shopify-section') : null);
          if (target && replacement) target.innerHTML = replacement.innerHTML;
        });
      });
      document.querySelectorAll('cart-items, cart-drawer, cart-drawer-items, #main-cart-footer').forEach((node) => node.classList.toggle('is-empty', state.payableCount + state.requestCount === 0));
      paint();
    }

    function enqueue(work) {
      pending++;
      paint();
      const execute = async () => {
        try { const result = await work(); error = null; return result; }
        catch (failure) { error = failure.message in config.text ? failure.message : 'error'; throw failure; }
        finally { pending--; paint(); }
      };
      const result = chain.then(() => navigator.locks ? navigator.locks.request('w121-shopify-cart', execute) : execute());
      chain = result.catch(() => {});
      return result;
    }

    function requestContext(args) {
      const body = args[1]?.body;
      try {
        const context = body instanceof FormData ? body.get('sections_url') : typeof body === 'string' ? JSON.parse(body).sections_url : null;
        return context || config.cartUrl;
      } catch { return config.cartUrl; }
    }

    async function perform(action, args) {
      if (window.WholesaleRequests?.blocks(args)) {
        return new Response(JSON.stringify({ status: 422, message: window.WholesaleRequests.blockedMessage, description: window.WholesaleRequests.blockedMessage }), { status: 422, headers: { 'Content-Type': 'application/json' } });
      }
      return enqueue(async () => {
        const response = await action();
        if (!response.ok) return response;
        const original = await response.clone().json();
        if (original.errors || original.status >= 400) return response;
        const { changed } = await reconcile(readState(original.sections?.['121-cart-state']));
        const nativeIds = Object.keys(original.sections || {});
        const allIds = [...new Set([...nativeIds, ...cartSections()])];
        const rendered = changed ? {} : { ...original.sections };
        const missingIds = allIds.filter((id) => typeof rendered[id] !== 'string');
        if (missingIds.length) Object.assign(rendered, await sections(missingIds, requestContext(args)));
        renderSections(rendered, nativeIds);
        let result = original;
        if (changed && Object.hasOwn(original, 'item_count')) result = { ...original, ...await (await request(`${config.root}cart.js`)).json() };
        if (nativeIds.length) result.sections = Object.fromEntries(nativeIds.map((id) => [id, rendered[id]]));
        channel?.postMessage('changed');
        return new Response(JSON.stringify(result), { status: response.status, statusText: response.statusText, headers: response.headers });
      });
    }

    function sync() {
      return enqueue(async () => {
        await reconcile();
        renderSections(await sections(cartSections()));
      });
    }

    async function checkout() {
      if (checkoutStarted || pending) return;
      checkoutStarted = true;
      try {
        await sync();
        if (canCheckout()) location.assign(`${config.root}checkout`);
      } catch {} finally { checkoutStarted = false; paint(); }
    }

    window.WholesaleCart = { perform, sync, canCheckout };
    const cartControls = '[data-w121-checkout], [data-w121-status], [data-w121-summary]';
    new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes].some((node) =>
        node.nodeType === 1 && (node.matches(cartControls) || node.querySelector(cartControls))
      ))) paint();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-w121-retry]')) { event.preventDefault(); sync().catch(() => {}); return; }
      if (event.target.closest('[name="checkout"], a[href*="/checkout"]')) {
        event.preventDefault(); event.stopImmediatePropagation(); checkout();
      }
    }, true);
    document.addEventListener('submit', (event) => {
      if (event.submitter?.name === 'checkout' || ['cart', 'CartDrawer-Form'].includes(event.target.id)) {
        event.preventDefault(); event.stopImmediatePropagation(); checkout();
      }
    }, true);
    window.addEventListener('pageshow', (event) => { if (event.persisted) sync().catch(() => {}); });
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') sync().catch(() => {}); });
    channel?.addEventListener('message', () => { if (document.visibilityState === 'visible') sync().catch(() => {}); });
    document.addEventListener('shopify:section:load', paint);
    if (config.initialItemCount > 0) sync().catch(() => {});
    else {
      state = { currency: 'GBP', taxesIncluded: false, goods: 0, goodsCount: 0, payableCount: 0, requestCount: 0, feeQuantity: 0, feeTotal: 0, fees: [] };
      paint();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["121-order-request"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const element = document.getElementById('w121-request-config');
    if (!element || window.WholesaleRequests) return;
    const config = JSON.parse(element.textContent);
    const dialog = document.getElementById('w121-request-dialog');
    const result = dialog.querySelector('[data-w121-request-result]');
    const form = dialog.querySelector('form');
    const submit = form.querySelector('[type="submit"]');
    const itemList = dialog.querySelector('[data-w121-request-items]');
    const pendingKey = `${config.storageKey}-pending`;
    const sentKey = `${config.storageKey}-sent`;
    const registry = new Map();
    let items = [];
    let inFlight = false;
    let attempt = 0;
    let previousFocus = null;
    let previousModal = null;
    const normalize = value => Number.isSafeInteger(value) && value >= 0 && value <= 9999 ? value : 0;
    const itemUrl = value => {
      try {
        const url = new URL(value, location.origin);
        return url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname) ? url : null;
      } catch { return null; }
    };
    function record(value) {
      if (!value || !/^\d+$/.test(String(value.variantId)) || !/^\d+$/.test(String(value.productId)) || !itemUrl(value.url)) return null;
      return { variantId: String(value.variantId), productId: String(value.productId), url: itemUrl(value.url).pathname, title: String(value.title || '').slice(0,500), variantTitle: String(value.variantTitle || '').slice(0,500), sku: String(value.sku || '').slice(0,200) };
    }
    function read() {
      try {
        const saved = JSON.parse(localStorage.getItem(config.storageKey));
        if (!Array.isArray(saved)) return [];
        const seen = new Set();
        return saved.slice(0,20).flatMap(value => {
          const item = record(value), quantity = normalize(value.quantity);
          if (!item || !quantity || seen.has(item.variantId)) return [];
          seen.add(item.variantId);
          return [{ ...item, quantity }];
        });
      } catch { return []; }
    }
    function register(node) {
      try {
        const data = record(JSON.parse(node.querySelector('[data-w121-request-item]')?.textContent || 'null'));
        const button = node.querySelector('[data-w121-request-button]');
        if (data) registry.set(data.variantId, data);
        if (button) button.disabled = inFlight || !data || button.dataset.w121RequestButton !== data.variantId;
      } catch { node.querySelector('[data-w121-request-button]')?.setAttribute('disabled',''); }
    }
    function renderSummary(node) {
      const quantity = items.reduce((total, item) => total + item.quantity, 0);
      node.hidden = quantity === 0;
      if (!quantity) { node.replaceChildren(); return; }
      const text = document.createElement('span');
      text.textContent = config.text.summary.replace('[quantity]', String(quantity));
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--primary w121-request-review';
      button.dataset.w121RequestReview = '';
      button.textContent = config.text.review;
      node.replaceChildren(text, button);
    }
    function render() {
      document.body.classList.toggle('w121-has-requests', items.length > 0);
      document.querySelectorAll('w121-request-summary').forEach(renderSummary);
      document.querySelectorAll('[data-w121-request-product]').forEach(register);
      dialog.querySelector('[data-w121-request-content]').hidden = items.length === 0;
      const activeVariant = itemList.contains(document.activeElement) ? document.activeElement.dataset.w121RequestQuantity : null;
      itemList.replaceChildren(...items.map(item => {
        const row = document.createElement('div'); row.className = 'w121-request-item';
        const detail = document.createElement('div');
        const title = document.createElement('strong'); title.textContent = item.title;
        const variant = document.createElement('p'); variant.textContent = item.variantTitle === 'Default Title' ? '' : item.variantTitle;
        const terms = document.createElement('p'); terms.textContent = config.text.terms;
        detail.append(title, variant, terms);
        const label = document.createElement('label');
        const name = document.createElement('span'); name.textContent = config.text.quantity;
        const input = document.createElement('input');
        Object.assign(input, { type:'number', min:'1', max:'9999', step:'1', value:String(item.quantity), inputMode:'numeric', required:true, disabled:inFlight });
        input.dataset.w121RequestQuantity = item.variantId;
        input.setAttribute('aria-label', `${config.text.quantity}: ${item.title} ${variant.textContent}`);
        label.append(name,input);
        const remove = document.createElement('button');
        remove.type = 'button'; remove.className = 'link'; remove.dataset.w121RequestRemove = item.variantId; remove.textContent = config.text.remove; remove.disabled = inFlight;
        row.append(detail,label,remove); return row;
      }));
      if (activeVariant) itemList.querySelector(`[data-w121-request-quantity="${activeVariant}"]`)?.focus({ preventScroll:true });
      submit.disabled = !items.length || inFlight;
    }
    function save(next) {
      items = next;
      try {
        if (items.length) localStorage.setItem(config.storageKey, JSON.stringify(items));
        else localStorage.removeItem(config.storageKey);
      } catch {}
      result.textContent = items.length ? '' : config.text.empty;
      render();
    }
    function open(trigger) {
      previousFocus = trigger;
      previousModal = trigger?.closest('modal-dialog, .product-quick-order-modal');
      document.querySelector('cart-drawer.active')?.close?.();
      if (previousModal) window.removeTrapFocus?.();
      render();
      if (!dialog.open) dialog.showModal();
    }
    function blocks(args) {
      try {
        const url = new URL(typeof args[0] === 'string' || args[0] instanceof URL ? args[0] : args[0].url, location.origin);
        if (url.origin !== location.origin) return false;
        const body = args[1]?.body;
        const data = body instanceof FormData || body instanceof URLSearchParams ? Object.fromEntries(body) : typeof body === 'string' ? JSON.parse(body) : {};
        const matches = (id, count) => registry.has(String(id).split(':')[0]) && Number(count ?? 1) > 0;
        if (/\/cart\/add(?:\.js)?$/.test(url.pathname)) return (data.items || [data]).some(item => matches(item.id,item.quantity));
        if (/\/cart\/update(?:\.js)?$/.test(url.pathname)) return Object.entries(data.updates || {}).some(([id,count]) => matches(id,count));
        if (/\/cart\/change(?:\.js)?$/.test(url.pathname)) return matches(data.id,data.quantity);
      } catch {}
      return false;
    }
    window.WholesaleRequests = { blocks, blockedMessage:config.text.blocked };
    items = read();
    if (!items.length && config.isDraft && config.legacyItem) {
      try {
        const old = JSON.parse(localStorage.getItem(config.legacyKey));
        const item = record(config.legacyItem);
        if (item && old?.variantId === item.variantId && normalize(old.quantity)) {
          save([{ ...item, quantity:old.quantity }]);
          localStorage.removeItem(config.legacyKey);
        }
      } catch {}
    }
    if (!customElements.get('w121-request-product')) customElements.define('w121-request-product', class extends HTMLElement { connectedCallback() { register(this); } });
    if (!customElements.get('w121-request-summary')) customElements.define('w121-request-summary', class extends HTMLElement { connectedCallback() { renderSummary(this); } });
    document.addEventListener('click', event => {
      const add = event.target.closest('[data-w121-request-button]');
      if (add) {
        event.preventDefault(); if (inFlight) return;
        const node = add.closest('[data-w121-request-product]'); register(node);
        const data = registry.get(add.dataset.w121RequestButton), input = node.querySelector('[data-w121-request-add-quantity]');
        if (!data || !input?.reportValidity() || !normalize(Number(input.value))) return;
        const current = items.find(item => item.variantId === data.variantId);
        if (!current && items.length >= 20) { result.textContent = config.text.limit; open(add); return; }
        const next = current ? items.map(item => item.variantId === data.variantId ? { ...data, quantity:Math.min(9999,item.quantity + Number(input.value)) } : item) : [...items,{ ...data,quantity:Number(input.value) }];
        save(next); open(add);
      } else if (event.target.closest('[data-w121-request-review]')) {
        event.preventDefault(); open(event.target.closest('[data-w121-request-review]'));
      } else if (event.target.closest('[data-w121-request-remove]')) {
        if (!inFlight) save(items.filter(item => item.variantId !== event.target.closest('[data-w121-request-remove]').dataset.w121RequestRemove));
      } else if (event.target.closest('[data-w121-request-close]')) dialog.close();
    });
    itemList.addEventListener('change', event => {
      const id = event.target.dataset.w121RequestQuantity;
      if (!inFlight && id && event.target.reportValidity()) save(items.map(item => item.variantId === id ? { ...item,quantity:Number(event.target.value) } : item));
    });
    form.addEventListener('input', event => event.target.setCustomValidity?.(''));
    async function verify(snapshot) {
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(),20000);
      const verified = new Array(snapshot.length); let cursor = 0;
      try {
        await Promise.all(Array.from({ length:Math.min(3,snapshot.length) }, async () => {
          while (cursor < snapshot.length) {
            const index = cursor++, item = snapshot[index], url = itemUrl(item.url);
            if (!url) throw new Error('eligibility');
            url.searchParams.set('variant', item.variantId);
            url.searchParams.set('section_id','121-request-product');
            url.searchParams.set('_w121_request',String(Date.now()));
            const response = await fetch(url.toString(),{ credentials:'same-origin',cache:'no-store',signal:controller.signal });
            if (!response.ok) throw new Error('eligibility');
            const html = new DOMParser().parseFromString(await response.text(),'text/html');
            const data = JSON.parse(html.querySelector('[data-w121-request-verification]')?.textContent || 'null');
            const canonical = record(data);
            if (!data?.eligible || !canonical || canonical.variantId !== item.variantId || canonical.productId !== item.productId) throw new Error('eligibility');
            verified[index] = { ...canonical, quantity:item.quantity };
          }
        }));
        return verified;
      } finally { clearTimeout(timer); controller.abort(); }
    }
    form.addEventListener('submit', async event => {
      event.preventDefault(); event.stopImmediatePropagation();
      if (inFlight) return;
      if (!items.length || form.querySelector('[data-w121-request-trap]').value) { result.textContent = config.text.invalid; return; }
      const snapshot = [];
      for (const item of items) {
        const input = itemList.querySelector(`[data-w121-request-quantity="${item.variantId}"]`), quantity = Number(input?.value);
        if (!normalize(quantity)) { input?.reportValidity(); return; }
        snapshot.push({ ...item,quantity });
      }
      form.querySelectorAll('[data-w121-request-address]').forEach(field => { field.required = true; });
      for (const field of form.querySelectorAll('[data-w121-request-plain]')) {
        field.value = field.value.trim();
        const badLength = (field.required && field.value.length < Math.max(1,field.minLength)) || (field.maxLength >= 0 && field.value.length > field.maxLength);
        field.setCustomValidity(/https?:\/\/|www\.|<[^>]*>/i.test(field.value) ? config.text.plainText : badLength ? config.text.invalid : '');
      }
      if (!form.reportValidity()) return;
      try {
        const lastSent = Math.max(Number(localStorage.getItem(sentKey)) || 0,Number(localStorage.getItem(`${config.legacyKey}-sent`)) || 0);
        if (lastSent > 0 && Date.now() - lastSent < 60000) { result.textContent = config.text.cooldown; return; }
      } catch {}
      if (typeof window.Shopify?.captcha?.protect !== 'function') { result.textContent = config.text.security; return; }
      save(snapshot); inFlight = true; render();
      const currentAttempt = ++attempt;
      result.textContent = config.text.checking;
      let verified;
      const failed = text => {
        if (currentAttempt !== attempt) return;
        attempt++; inFlight = false; render(); result.textContent = text;
      };
      try { verified = await verify(snapshot); } catch { failed(config.text.verification); return; }
      if (currentAttempt !== attempt) return;
      const reference = `121-${crypto.randomUUID()}`;
      form.querySelector('[data-w121-request-reference]').value = reference;
      form.querySelector('[data-w121-request-body]').value = [
        'ITEMS REQUESTED', '',
        ...verified.flatMap((item,index) => [`${index + 1}. ${item.title}`, ...(item.variantTitle && item.variantTitle !== 'Default Title' ? [`Option: ${item.variantTitle}`] : []), `Quantity: ${item.quantity} selected pack(s) / carton(s)`, `SKU: ${item.sku || 'Not supplied'}`, '']),
        'Price, availability and lead time: to be confirmed.', '',
        'STAFF REVIEW',
        'Check the business, delivery address and contact details independently before accepting.',
        'Enquiry only — NOT AN ORDER. No stock reserved or payment terms approved.'
      ].join('\n');
      result.textContent = config.text.sending;
      const timeout = setTimeout(() => failed(config.text.security),20000);
      try {
        window.Shopify.captcha.protect(form, () => {
          if (currentAttempt !== attempt) return;
          clearTimeout(timeout);
          try { sessionStorage.setItem(pendingKey,JSON.stringify({ items:verified.map(({variantId,quantity}) => ({variantId,quantity})),reference,time:Date.now() })); } catch {}
          try { form.submit(); } catch { failed(config.text.security); }
        });
      } catch { clearTimeout(timeout); failed(config.text.security); }
    },true);
    dialog.addEventListener('close', () => {
      const returnTo = previousFocus?.isConnected && !previousFocus.closest('cart-drawer') ? previousFocus : document.getElementById('cart-icon-bubble');
      if (previousModal?.isConnected) window.trapFocus?.(previousModal.querySelector('[role="dialog"]') || previousModal,returnTo);
      else returnTo?.focus();
    });
    window.addEventListener('storage', event => { if (event.key === config.storageKey) { items = read(); result.textContent = ''; render(); } });
    document.addEventListener('shopify:section:load',render);
    window.addEventListener('pageshow', event => { if (event.persisted) { attempt++; inFlight = false; items = read(); result.textContent = ''; render(); } });
    render();
    const serverState = form.querySelector('[data-w121-request-server]')?.dataset.w121RequestServer;
    let pending; try { pending = JSON.parse(sessionStorage.getItem(pendingKey)); } catch {}
    const isReturn = location.hash === '#w121-request-form' && Array.isArray(pending?.items) && Date.now() - pending.time < 1800000;
    if (isReturn && serverState) {
      if (serverState === 'success') {
        save(items.filter(item => !pending.items.some(sent => sent.variantId === item.variantId && sent.quantity === item.quantity)));
        try { localStorage.setItem(sentKey,String(Date.now())); sessionStorage.removeItem(pendingKey); } catch {}
        form.reset(); result.textContent = config.text.sent;
      }
      open(null);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{ once:true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
